<div class="header">
  <div class="header-left">
    <mat-icon>pending_actions</mat-icon>
    <h3>Data Inputs Modifications Log</h3>
  </div>
  @if (rawData$ | async; as data) {
    <button
      [disabled]="!entryType || data.length === 0"
      (click)="downloadDocument()"
      mat-stroked-button
      color="primary"
      >
      <mat-icon>download</mat-icon> DOWNLOAD
    </button>
  }
</div>
<div class="body">
  <div class="form-container">
    <mat-form-field>
      <mat-label>Inspection Entry Type</mat-label>
      <mat-select
        [(ngModel)]="entryType"
        (ngModelChange)="handleDropdownChange($event, 1)"
        >
        @for (entryType of entryTypes; track entryType.value) {
          <mat-option [value]="entryType.value">{{
            entryType.label
          }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (numberOfDropdowns > 1 && typeOfDropdown == 1) {
      <mat-form-field>
        <mat-label>Item Name</mat-label>
        <mat-select
          [(ngModel)]="item"
          (ngModelChange)="handleDropdownChange($event, 2)"
          >
          @for (item of items; track item.value) {
            <mat-option [value]="item.value">{{ item.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (
      (numberOfDropdowns > 1 && typeOfDropdown == 2) ||
      (numberOfDropdowns > 2 && typeOfDropdown == 1)
      ) {
      <mat-form-field>
        <mat-label>Section</mat-label>
        <mat-select
          [(ngModel)]="section"
          (ngModelChange)="handleDropdownChange($event, 3)"
          >
          @for (section of sections; track section.value) {
            <mat-option [value]="section.value">{{ section.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (
      (numberOfDropdowns > 2 && typeOfDropdown == 2) ||
      (numberOfDropdowns > 3 && typeOfDropdown == 1)
      ) {
      <mat-form-field>
        <mat-label>Input Field Name</mat-label>
        <mat-select
          [(ngModel)]="inputField"
          (ngModelChange)="handleDropdownChange($event, 4)"
          >
          @for (inputField of inputFields; track inputField.value) {
            <mat-option [value]="inputField.value">{{
              inputField.label
            }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <div class="button-container">
      <button
        [disabled]="!entryType"
        (click)="clearFormState()"
        mat-flat-button
        color="primary"
        >
        CLEAR
      </button>
    </div>
  </div>

  <div class="content">
    @if (rawData$ | async; as data) {
      @if (entryType != null && data.length > 0) {
        <div
          class="infiniteScroll"
          (cotecnaInfiniteScroll)="loadNextPage()"
          cotecna-infinite-scroll
          cotecna-automatic-height
          >
          @switch (typeOfDropdown) {
            @case (DropdownType.GeneralInfo) {
              <cotecna-table
                #dynamicTable
                [data]="data"
                [dateFormat]="'dd/MM/yyyy'"
                [dateTimeFormat]="'dd/MM/yyyy HH:mm'"
                [columns]="generalInfoColumns"
                [hasInfiniteScroll]="true"
                [fixedHeader]="true"
                [ngClass]="getTableInteractionClass()"
                >
              </cotecna-table>
            }
            @case (DropdownType.Items) {
              <cotecna-table
                #dynamicTable
                [data]="data"
                [dateFormat]="'dd/MM/yyyy'"
                [dateTimeFormat]="'dd/MM/yyyy HH:mm'"
                [columns]="itemsColumns"
                [hasInfiniteScroll]="true"
                [fixedHeader]="true"
                [ngClass]="getTableInteractionClass()"
                >
              </cotecna-table>
            }
            @case (DropdownType.ScopeOfWork) {
              <cotecna-table
                #dynamicTable
                [data]="data"
                [dateFormat]="'dd/MM/yyyy'"
                [dateTimeFormat]="'dd/MM/yyyy HH:mm'"
                [columns]="scopeOfWorkColumns"
                [hasInfiniteScroll]="true"
                [fixedHeader]="true"
                [ngClass]="getTableInteractionClass()"
                >
              </cotecna-table>
            }
          }
        </div>
      }
      <mat-card-actions>
        @if (isLoading) {
          <mat-spinner diameter="32"></mat-spinner>
        }
      </mat-card-actions>
      @if (entryType != null && data.length === 0) {
        <p>
          @if (typeOfDropdown === 1 && numberOfDropdowns === 2) {
            <span>SELECT AN ITEM NAME TO VIEW THE LOG</span>
          }
          @else {
          <span>NO DATA AVAILABLE FOR THE SELECTED CRITERIA</span>
        }
      </p>
    }
  }

  @if (entryType == null) {
    <p>SELECT ENTRY TYPE TO VIEW LOG</p>
  }
</div>
</div>
